import service from '@/plugins/request'

//获取首页活动
export const getActivity = (params) => {
    return service({
        url: 'app/home/getActivity',
        method: 'get',
        params,
        hideErrMsg: true
    })
}

export const getScreenActivity = (params) => {
    return service({
        url: 'app/home/getScreenActivity',
        method: 'get',
        params,
        hideErrMsg: true
    })
}

export const getSiteSetting = (params) => {
    return service({
        url: 'app/home/getSiteSetting',
        method: 'get',
        params,
        hideErrMsg: true
    })
}

export const webOpen = (data) => {
    return service({
        url: 'app/report/webOpen',
        method: 'put',
        data,
        hideErrMsg: true
    })
}

export const getDomainChannel = (params) => {
    return service({
        url: 'app/home/getDomainChannel',
        method: 'get',
        params,
        hideErrMsg: true
    })
}

export const getArticle = (params) => {
    return service({
        url: 'app/home/getArticle',
        method: 'get',
        params,
        hideErrMsg: true
    })
}


